module.exports = __webpack_public_path__ + "static/media/Vedio.1974bb47.svg";